import { Component, Input } from '@angular/core'

// Reusable, domain-agnostic "this value was prefilled" indicator (FR4 — icon + text
// label, never colour alone). Not exercised by any field in story e8-1 (Step 1 has no
// prefilled fields) — built now as scaffolding so e8-2+ stories (e.g. Step 2's NDIS
// number) can consume it unmodified. Pass `id` and point the prefilled control's own
// `aria-describedby` at it.
@Component({
  selector: 'app-prefilled-field-badge',
  templateUrl: './prefilled-field-badge.component.html',
  styleUrls: ['./prefilled-field-badge.component.scss'],
  standalone: false,
})
export class PrefilledFieldBadgeComponent {
  @Input() id: string = ''
  @Input() labelKey: string = 'SERVICE_PLAN.PREFILLED_BADGE.LABEL'
}
